import { Outlet, createBrowserRouter } from 'react-router-dom';
import AdminLogin from './components/auth/AdminLogin';
import Login from './components/auth/UserLogin';
import MainLayout from './components/ui/layouts/main.layout';
import { AuthProvider } from './contexts/AuthContext';
import { NotificationProvider } from './contexts/NotificationContext';
import { PendingRequestsProvider } from './contexts/PendingRequestsProvider';
import { TokenListProvider } from './contexts/TokenListContext';
import { WalletProvider } from './contexts/WalletContext';
import ProtectedRoute from './layout/ProtectedRoute';
import CashOut from './pages/CashOut';
import Dashboard from './pages/Dashboard';
import MintTokenPage from './pages/MintTokenPage';
import ReportsPage from './pages/ReportsPage';
import SettingsPage from './pages/SettingsPage';
import Settlement from './pages/Settlement';
import TokenDashboard from './pages/TokenDashboardPage/index2';
import TokenTransferPage from './pages/TokenTransferPage';
import TransactionsPage from './pages/TransactionsPage';
import UserDetailsPage from './pages/UserDetailsPage';
import UsersManagement from './pages/UsersManagement';
import VoucherGiftCards from './pages/VoucherGiftCards';
import Wallet from './pages/Wallet';
import ProfilePage from './pages/ProfilePage';
import RequestedTokenHistory from './pages/RequestedToken';
import LandingPage from './pages/LandingPage';
import PrivacyPolicy from './pages/PrivacyAndTerms/PrivacyPolicy';
import TermsAndConditions from './pages/PrivacyAndTerms/TermsAndConditions';
import GiftCard from './pages/GiftCard';
import VendorHistory from './pages/VendorHistory';
import TransactionsAllPage from './pages/TransactionAll';

const routes = createBrowserRouter([
  {
    path: '/admin-login',
    element: (
      <ProtectedRoute>
        <AdminLogin />
      </ProtectedRoute>
    ),
  },
  {
    path: '/login',
    element: (
      <ProtectedRoute>
        <Login />
      </ProtectedRoute>
    ),
  },
  {
    path: '/',
    element: <LandingPage />,
  },
  {
    path: '/privacy-policy',
    element: <PrivacyPolicy />,
  },
  {
    path: '/terms-and-conditions',
    element: <TermsAndConditions />,
  },
  {
    path: '/',
    element: (
      <ProtectedRoute>
        <NotificationProvider>
          <TokenListProvider>
            <WalletProvider>
              <PendingRequestsProvider>
                <MainLayout />
              </PendingRequestsProvider>
            </WalletProvider>
          </TokenListProvider>
        </NotificationProvider>
      </ProtectedRoute>
    ),
    children: [
      {
        path: '/dashboard',
        element: <Dashboard />,
      },
      {
        path: '/profile',
        element: <ProfilePage />,
      },
      {
        path: '/wallet',
        element: <Wallet />,
      },
      {
        path: 'transactions',
        element: <TransactionsPage />,
      },
      {
        path: 'cash-out',
        element: <CashOut />,
      },
      {
        path: 'voucher-gift-cards',
        element: <VoucherGiftCards />,
      },
      {
        path: '/token-management',
        element: <Outlet />,
        children: [
          {
            path: '',
            element: <TokenDashboard />,
          },
          {
            path: '/token-management/mint-token',
            element: <MintTokenPage />,
          },
          {
            path: '/token-management/transfer-token',
            element: <TokenTransferPage />,
          },
        ],
      },
      {
        path: '/user-management',
        element: <Outlet />,
        children: [
          {
            path: '',
            element: <UsersManagement />,
          },
          {
            path: 'details',
            element: <UserDetailsPage />,
          },
        ],
      },
      // {
      //   path: 'rbac',
      //   element: <Rbac />,
      // },
      {
        path: 'settlement',
        element: <Settlement />,
      },
      {
        path: 'reports',
        element: <ReportsPage />,
      },
      {
        path: 'settings',
        element: <SettingsPage />,
      },
      {
        path: 'requested-token',
        element: <RequestedTokenHistory />,
      },
      {
        path: 'gift-cards',
        element: <GiftCard />,
      },
      {
        path: 'transactions-all',
        element: <TransactionsAllPage />,
      },
      {
        path: 'vendor',
        element: <Outlet />,
        children: [
          {
            path: '',
            element: <VendorHistory />,
          },
        ],
      },
    ],
  },
]);

export default routes;
